import { AdminWorkspacesPage } from '@/features/admin/pages/AdminWorkspacesPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/workspaces')({
  component: AdminWorkspacesPage,
});
